import { render, staticRenderFns } from "./BotRedirect.vue?vue&type=template&id=adde4426&"
import script from "./BotRedirect.vue?vue&type=script&lang=js&"
export * from "./BotRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports